
// 上架状态映射
export const shelfStatusMap = new Map([
  [0, { color: '#BFBFBF', context: '已下架' }],
  [1, { color: '#3EBE0C', context: '已上架' }],
]);

// 审核类型映射
export const apptTypeMap = new Map([
  [1, '人工审核'],
  [2, '自动审核'],
])
// 支付模式映射
export const payTypeMap = new Map([
  [1, '在线支付'],
  [2, '线下支付'],
])
// 服务形式映射
export const serviceTypeMap = new Map([
  [1, '到店服务'],
  [2, '上门服务'],
])
